import classNames from "classnames";
import React, { useMemo } from "react";
import { Container, Heading3, Tabs } from "shared/components";
import { TabsProvider } from "shared/components/Tabs/Tabs.Provider";

import styles from "./Content007.module.scss";
import { Documents } from "./Documents";

export const Content007 = ({ payload }) => {
  const title = payload?.title ?? "";
  const areTabsEnabled = payload?.showTab ?? true;
  const documents = useMemo(() => payload?.documentList ?? [], [payload]);
  const attachments = useMemo(
    () => payload?.documentAttachments ?? [],
    [payload]
  );

  const extractedTabs = useMemo(() => {
    return [...new Set(documents.map((item) => item.course.title))];
  }, [documents]);

  return (
    <div className={styles.wrapper}>
      <TabsProvider items={extractedTabs} tabsEnabled={areTabsEnabled}>
        <Container className={styles.inner}>
          <div className={styles.top}>
            <div
              className={classNames(styles.header, {
                [styles["header-margin"]]: areTabsEnabled,
              })}
            >
              <Heading3 as="h3">{title}</Heading3>
            </div>
            <Tabs appearance="justify" />
          </div>
        </Container>
        <div className={styles.content}>
          <Container className={styles.inner}>
            <Documents attachments={attachments} documents={documents} />
          </Container>
        </div>
      </TabsProvider>
    </div>
  );
};

export default Content007;
